import * as React from "react"
import type { SVGProps } from "react"
const SvgEmailDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 9q.425 0 .713.287Q15 9.575 15 10a.97.97 0 0 1-.287.713A.97.97 0 0 1 14 11h-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 9 10q0-.425.287-.713A.97.97 0 0 1 10 9zM15 6q.425 0 .713.287Q16 6.575 16 7a.97.97 0 0 1-.287.713A.97.97 0 0 1 15 8H9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 8 7q0-.425.287-.713A.97.97 0 0 1 9 6z" />
    <path
      fillRule="evenodd"
      d="M18 2q.825 0 1.412.588Q20 3.176 20 4v3.122l1.05.628q.45.274.7.75.25.475.25 1V20q0 .825-.588 1.413A1.93 1.93 0 0 1 20 22H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 20V9.5q0-.525.25-1 .25-.476.7-.75L4 7.122V4q0-.824.588-1.412A1.93 1.93 0 0 1 6 2zm-4.975 13.725A2 2 0 0 1 12 16q-.55 0-1.025-.275L4 11.55V20h16v-8.45zM6 4v6.423L12 14l6-3.577V4z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgEmailDocument
